import { useState } from 'react';
import { Link, fmtCredits, fmtDate, targetsTitle, useApi } from '../lib.jsx';
import { CreditMeter } from '../ui.jsx';
import { ChangePassword } from './SignIn.jsx';
import { McpSummary } from './Mcp.jsx';

const ADDED = { free: 'Free credits', payment: 'Credits added', correction: 'Correction' };
const added = (g) => (g.kind === 'correction' && g.credits < 0 ? 'Credits removed' : ADDED[g.kind] ?? 'Credits');
const signed = (x) => `${x > 0 ? '+' : x < 0 ? '−' : ''}${fmtCredits(Math.abs(x))}`;

/** Credits (what was added, what each report used) and the login. Never what anything cost in money. */
export function Account({ user, credits: c }) {
  const account = useApi('/api/account');
  const runs = useApi('/api/runs');
  const [password, setPassword] = useState(false);
  const a = account.data;
  const used = (runs.data?.runs ?? []).filter((r) => r.credits > 0);
  return (
    <div className="page">
      <div className="page-head">
        <div>
          <p className="eyebrow">Account</p>
          <h1>Your <em>account</em></h1>
          <p className="muted">Credits, what used them, and your login.</p>
        </div>
      </div>
      <div className="account-grid">
        <div className="account-main">
          {c ? (
            <section className="panel">
              <h2>Credits</h2>
              <p className="sub">{c.team ? 'Team account: research is not limited by credits.' : 'Research uses credits as it collects and reads posts and comments. Reading reports, exporting and the sample report never do.'}</p>
              <div className="credit-figures">
                <div><span className="label">Added</span><span className="value">{fmtCredits(c.total)}</span></div>
                <div><span className="label">Used</span><span className="value">{fmtCredits(c.used)}</span></div>
                {c.team ? null : <div className="left"><span className="label">Left</span><span className="value">{fmtCredits(c.left)}</span></div>}
              </div>
              {c.team ? null : <CreditMeter used={c.used} total={c.total} />}
              {c.team ? null : <p className="small muted">Need more? Ask the Yapscape team and they are added to this account.</p>}
            </section>
          ) : null}
          <section className="panel">
            <h2>Credits used by report</h2>
            <p className="sub">What each piece of research used. Running research holds what it may need and gives back what it does not use.</p>
            {!runs.data || !a ? <p className="muted small">Loading…</p> : used.length || a.other || a.held ? (
              <div className="table-wrap"><table className="data">
                <thead><tr><th>Report</th><th>Started</th><th className="num">Credits</th></tr></thead>
                <tbody>
                  {used.map((r) => <tr key={r.id}><td><Link to={`/runs/${r.id}`}>{targetsTitle(r.targets)}</Link></td><td className="small">{fmtDate(r.createdAt)}</td><td className="num">{fmtCredits(r.credits)}</td></tr>)}
                  {a.held ? <tr><td>Held by research still running</td><td /><td className="num">{fmtCredits(a.held)}</td></tr> : null}
                  {a.other ? <tr><td>Name ideas and checks while setting up research, and deleted research</td><td /><td className="num">{fmtCredits(a.other)}</td></tr> : null}
                </tbody>
              </table></div>
            ) : <p className="muted small">Nothing used yet. <Link to="/new">Start your first research</Link>.</p>}
          </section>
          <McpSummary />
        </div>
        <div className="account-side">
          <section className="panel">
            <h2>Login</h2>
            <dl className="kv">
              {user.name ? <div><dt>Name</dt><dd>{user.name}</dd></div> : null}
              <div><dt>Email</dt><dd>{user.email}</dd></div>
              <div><dt>Company</dt><dd>{user.workspace.name}</dd></div>
              {a?.jobTitle ? <div><dt>Job title</dt><dd>{a.jobTitle}</dd></div> : null}
            </dl>
            <div className="row-actions"><button type="button" className="btn" onClick={() => setPassword(true)}>Change password</button></div>
          </section>
          <section className="panel">
            <h2>Credit history</h2>
            {!a ? <p className="muted small">Loading…</p> : a.grants.length ? (
              <ul className="ledger">
                {a.grants.map((g, i) => <li key={i}><span><b>{added(g)}</b><span className="small muted">{fmtDate(g.at)}</span></span><span className={`amount${g.credits < 0 ? ' neg' : ''}`}>{signed(g.credits)}</span></li>)}
              </ul>
            ) : <p className="muted small">No credits added yet.</p>}
          </section>
        </div>
      </div>
      {password ? <ChangePassword onClose={() => setPassword(false)} /> : null}
    </div>
  );
}

